module.exports = __webpack_public_path__ + "img/ticket_icon_gift.62e4a5da.svg";